import Vue from 'vue'
import {withConfirmation} from '@/decorators/withConfirmation'
import {ERROR} from '@/store/modules/ui/UI'

export const checkIsWebExpensesApp = () => {
    return window.location.hostname.includes('webexpenses')
}

export const checkIsUkWebExpensesApp = () => {
    return window.location.hostname.includes('uk.webexpenses')
}

export const clearAppLocalStorageAndCache = () => {
    withConfirmation({
        title: 'Clear local storage and cache',
        description: `
            <div class="text-muted font-14 mb-2">
                This will not affect your data in any way.</br>
                The current session will be terminated which will require <span class="text-purple">re-login.</span>
            </div>
            Are you sure you want to continue?
        `,
        onConfirm: onClearAppLocalStorageAndCache
    })
}

export const onClearAppLocalStorageAndCache = async() => {
    try {
        localStorage.clear()
        await caches.keys().then((names) => Promise.all(names.map((key) => caches.delete(key))))
        location.reload()
    } catch (e) {
        Vue.prototype.$snackbar.show({
            type: ERROR,
            text: 'Something went wrong.',
            caption: `
                Your browser is probably incompatible with clearing the cache programmatically.</br>
                Please try to do it manually in your browser settings.
            `,
            duration: 100000,
            withClose: true
        })
    }
}
